import { render, staticRenderFns } from "./icon-more-horizontal.vue?vue&type=template&id=7689a3e1&"
import script from "./icon-more-horizontal.vue?vue&type=script&lang=js&"
export * from "./icon-more-horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports